/* eslint-disable no-restricted-syntax */
import {
  LIVE_UPDATE_STRATEGY_SELECTED,
  SET_SOCKET_FAILURE,
} from '../constants/actions';
import { SUCCESS } from '../constants/general';

export const initialState = {
  socketObject: null,
  liveUpdateStrategySelected: null,
  subscribedTopics: {},
  topicHandler: null,
};

const socket = (state = initialState, action) => {
  switch (action.type) {
    case LIVE_UPDATE_STRATEGY_SELECTED:
      return { ...state, liveUpdateStrategySelected: SUCCESS };
    case SET_SOCKET_FAILURE:
      return { ...state, liveUpdateStrategySelected: 'websockets-failure' };
    default:
      return { ...state };
  }
};

export default socket;
